import IOrderAddress from '../entities/IOrderPrivatePackageAddress';
import {
    FormGroup,
    FormControl,
    ControlLabel,
    HelpBlock,
    Checkbox,
    Row,
    Col
} from 'react-bootstrap';
import { Translate } from '../../../../../shared/LanguageService';
import * as React from 'react';
import FormValidationService from '../../../../../shared/form/FormValidationService';
import FormSelect from '../../../../../components/common/FormSelect';
import AddressMapButton from '../../../../../components/common/addressValidation/AddressMapButton';
import ICoordinate from '../../../../map/ICoordinate';

interface IAddressModalFormProps {
    orderAddress: IOrderAddress;
    onChange: (e: any) => void;
    onCustomChange: (target: string, value: any) => void;
    errors: any;
    isPackageOrder: boolean;
    isCommercial: boolean;
    availablePrivateObjectTypes: any;
    availableCommercialObjectTypes: any;
    availableContactPersons: any;
}

const AddressModalForm = (props: IAddressModalFormProps) => {
    return (
        <form>
            <FormGroup
                className="required"
                validationState={FormValidationService.getValidationState(
                    props.errors['address.AddressLine1']
                )}
            >
                <ControlLabel>
                    {Translate('view-order/contact/modal/form/input-label/address-line-1')}
                </ControlLabel>
                <FormControl
                    autoFocus
                    type="text"
                    name="addressLine1"
                    value={props.orderAddress.addressLine1}
                    onChange={props.onChange}
                />
                <HelpBlock>{props.errors['address.AddressLine1']}</HelpBlock>
            </FormGroup>

            <FormGroup
                className="required"
                validationState={FormValidationService.getValidationState(
                    props.errors['address.AddressCity']
                )}
            >
                <ControlLabel>
                    {Translate('view-order/contact/modal/form/input-label/address-city')}
                </ControlLabel>
                <FormControl
                    autoFocus
                    type="text"
                    name="addressCity"
                    value={props.orderAddress.addressCity}
                    onChange={props.onChange}
                />
                <HelpBlock>{props.errors['address.AddressCity']}</HelpBlock>
            </FormGroup>
            {props.isPackageOrder && (
                <div>
                    <Row>
                        <Col xs={11}>
                            <FormGroup
                                className="required"
                                validationState={FormValidationService.getValidationState(
                                    props.errors['address.AddressPostalNumber']
                                )}
                            >
                                <ControlLabel>
                                    {Translate(
                                        'view-order/contact/modal/form/input-label/address-postal-number'
                                    )}
                                </ControlLabel>
                                <FormControl
                                    autoFocus
                                    type="text"
                                    name="addressPostalNumber"
                                    value={props.orderAddress.addressPostalNumber}
                                    onChange={props.onChange}
                                />
                                <HelpBlock>{props.errors['address.AddressPostalNumber']}</HelpBlock>
                            </FormGroup>
                        </Col>
                        <AddressMapButton
                            addressLine={props.orderAddress.addressLine1}
                            onAddressLineChange={(addressLine1: string) =>
                                props.onCustomChange('addressLine1', addressLine1)
                            }
                            postalNumber={props.orderAddress.addressPostalNumber}
                            onPostalNumberChange={(postalNumber: string) =>
                                props.onCustomChange('addressPostalNumber', postalNumber)
                            }
                            city={props.orderAddress.addressCity}
                            onCityChange={(city: string) =>
                                props.onCustomChange('addressCity', city)
                            }
                            point={props.orderAddress.addressPointLocation}
                            onPointChange={(point: ICoordinate) =>
                                props.onCustomChange('addressPointLocation', point)
                            }
                            error={props.errors['address.AddressPointLocation']}
                        />
                    </Row>
                    {!props.isCommercial && (
                        <div>
                            {' '}
                            <FormGroup
                                validationState={FormValidationService.getValidationState(
                                    props.errors['address.AddressDistrict']
                                )}
                            >
                                <ControlLabel>
                                    {Translate(
                                        'view-order/contact/modal/form/input-label/address-district'
                                    )}
                                </ControlLabel>
                                <FormControl
                                    autoFocus
                                    type="text"
                                    name="addressDistrict"
                                    value={props.orderAddress.addressDistrict}
                                    onChange={props.onChange}
                                />
                                <HelpBlock>{props.errors['address.AddressDistrict']}</HelpBlock>
                            </FormGroup>
                            <FormGroup
                                validationState={FormValidationService.getValidationState(
                                    props.errors['address.AddressSquareMeters']
                                )}
                            >
                                <ControlLabel>
                                    {Translate(
                                        'view-order/contact/modal/form/input-label/object-area-square-meters'
                                    )}
                                </ControlLabel>
                                <FormControl
                                    autoFocus
                                    type="number"
                                    name="objectAreaSquareMeters"
                                    value={
                                        props.orderAddress.objectAreaSquareMeters
                                            ? props.orderAddress.objectAreaSquareMeters
                                            : ''
                                    }
                                    onChange={props.onChange}
                                />
                                <HelpBlock>{props.errors['address.AddressSquareMeters']}</HelpBlock>
                            </FormGroup>
                            <FormGroup
                                validationState={FormValidationService.getValidationState(
                                    props.errors['address.AddressNumberOfRooms']
                                )}
                            >
                                <ControlLabel>
                                    {Translate(
                                        'view-order/contact/modal/form/input-label/object-number-of-rooms'
                                    )}
                                </ControlLabel>
                                <FormControl
                                    autoFocus
                                    type="number"
                                    name="objectNumberOfRooms"
                                    value={
                                        props.orderAddress.objectNumberOfRooms
                                            ? props.orderAddress.objectNumberOfRooms
                                            : ''
                                    }
                                    onChange={props.onChange}
                                />
                                <HelpBlock>
                                    {props.errors['address.AddressNumberOfRooms']}
                                </HelpBlock>
                            </FormGroup>
                        </div>
                    )}
                    <FormGroup
                        className="required"
                        validationState={FormValidationService.getValidationState(
                            props.errors['address.ObjectType']
                        )}
                    >
                        <ControlLabel>
                            {Translate(
                                'view-order/contact/modal/form/select-object-type-placeholder'
                            )}
                        </ControlLabel>
                        <FormSelect
                            componentClass="select"
                            name="objectType"
                            value={
                                props.orderAddress.objectType
                                    ? props.orderAddress.objectType.toString()
                                    : ''
                            }
                            onChange={props.onChange}
                        >
                            <option key="-1" value="-1">
                                {Translate('view-order/contact/modal/form/input-label/object-type')}
                            </option>
                            {!props.isCommercial &&
                                props.availablePrivateObjectTypes.map((x: any) => (
                                    <option value={x.id} key={x.id}>
                                        {Translate(x.name)}
                                    </option>
                                ))}

                            {props.isCommercial &&
                                props.availableCommercialObjectTypes.map((x: any) => (
                                    <option value={x.id} key={x.id}>
                                        {Translate(x.name)}
                                    </option>
                                ))}
                        </FormSelect>
                        <HelpBlock>{props.errors['address.ObjectType']}</HelpBlock>
                    </FormGroup>
                    {!props.isCommercial && props.orderAddress.objectType === 1 && (
                        <div>
                            <FormGroup
                                validationState={FormValidationService.getValidationState(
                                    props.errors.apartmentHasBalcony
                                )}
                            >
                                <ControlLabel>
                                    {Translate(
                                        'view-order/contact/modal/form/input-label/object-type/apartment/has-balcony'
                                    )}
                                </ControlLabel>
                                <Checkbox
                                    name="apartmentHasBalcony"
                                    checked={props.orderAddress.apartmentHasBalcony}
                                    onChange={props.onChange}
                                >
                                    <span></span>
                                </Checkbox>
                            </FormGroup>

                            <FormGroup
                                className="required"
                                validationState={FormValidationService.getValidationState(
                                    props.errors['address.ApartmentFloor']
                                )}
                            >
                                <ControlLabel>
                                    {Translate(
                                        'view-order/contact/modal/form/input-label/object-type/apartment/floor'
                                    )}
                                </ControlLabel>
                                <FormControl
                                    autoFocus
                                    type="text"
                                    name="apartmentFloor"
                                    value={props.orderAddress.apartmentFloor}
                                    onChange={props.onChange}
                                />
                                <HelpBlock>{props.errors['address.ApartmentFloor']}</HelpBlock>
                            </FormGroup>
                            <FormGroup
                                validationState={FormValidationService.getValidationState(
                                    props.errors['address.ApartmentAccessCode']
                                )}
                            >
                                <ControlLabel>
                                    {Translate(
                                        'view-order/contact/modal/form/input-label/object-type/apartment/access-code'
                                    )}
                                </ControlLabel>
                                <FormControl
                                    autoFocus
                                    type="text"
                                    name="apartmentAccessCode"
                                    value={props.orderAddress.apartmentAccessCode}
                                    onChange={props.onChange}
                                />
                                <HelpBlock>{props.errors['address.ApartmentAccessCode']}</HelpBlock>
                            </FormGroup>
                        </div>
                    )}
                    {!props.isCommercial && (
                        <FormGroup
                            className="required"
                            validationState={FormValidationService.getValidationState(
                                props.errors['address.ContactPerson']
                            )}
                        >
                            <ControlLabel>
                                {Translate(
                                    'view-order/contact/modal/form/input-label/contact-person'
                                )}
                            </ControlLabel>
                            <FormSelect
                                type="text"
                                name="contactPerson"
                                value={
                                    props.orderAddress.contactPerson
                                        ? props.orderAddress.contactPerson.toString()
                                        : ''
                                }
                                onChange={props.onChange}
                            >
                                <option key="-1" value="-1">
                                    {Translate(
                                        'view-order/contact/modal/form/select-contact-person-placeholder'
                                    )}
                                </option>
                                {props.availableContactPersons.map((x: any) => (
                                    <option value={x.id} key={x.id}>
                                        {Translate(x.name)}
                                    </option>
                                ))}
                            </FormSelect>
                            <HelpBlock>{props.errors['address.ContactPerson']}</HelpBlock>
                        </FormGroup>
                    )}
                </div>
            )}
        </form>
    );
};

export default AddressModalForm;
